import React from 'react';

import Headline from 'Core/Components/Headline';
import Overlay from 'Core/Components/Overlay';

class Hero extends React.Component {
  constructor (props) {
    super(props);
  }

  iconFromType (type) {
    switch (type) {
      case 'download':
        return (
          <div className="icon">
            <img src="assets/arrow-down-black.png" />
          </div>
        );
    }
  }

  buildButtons (buttons = []) {
    buttons = !Array.isArray(buttons) ? null : buttons
      .map(({ text, type, url, icon }, index) => {
        icon = (icon ? icon : this.iconFromType(type));
        const Tag = url ? 'a' : 'span';
        return (
          <Tag key={index} href={url} target="_blank">
            <button className="split">
              <span>{text}</span>
              {icon}
            </button>
          </Tag>
        )
      }
    );
    return buttons;
  }

  render () {
    let { background, title, buttons, wrap } = ('hero' in this.props ? this.props.hero : this.props);
    background = background ? background : {};
    buttons = this.buildButtons(buttons);
    let className = 'grid HeroInner' + (background.overlayClass ? ' ' + background.overlayClass : '');

    return (
      <div className="Hero">
        <Overlay
          className={className}
          image={background.image}
          overlay={background.overlay}
          position={background.position}
          innerClass="page-heading-content"
        >
          {title && <Headline wrap={wrap} align="left" text={title} />}
          {buttons && <div className="button-area">{buttons}</div>}
        </Overlay>
      </div>
    );
  }
};

export default Hero;



// WEBPACK FOOTER //
// ./client/Site/Ui/Hero.jsx